import {
  Button,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import React from "react";
import { BACKGROUND_COLOR_DARK } from "../../constants";

const FillGstDetailsModal = ({
  isGstDetailsModalOpen,
  closeGstDetailsModal,
  setFormValues,
  formValues,
  handleFormSubmit,
  handleGstDetailsModalCancel,
}) => {
  return (
    <Modal
      isOpen={isGstDetailsModalOpen}
      onClose={closeGstDetailsModal}
      isCentered
      size={"sm"}
    >
      <ModalOverlay />
      <ModalContent borderRadius={"20px"} py={3} px={1}>
        <ModalHeader>GSTIN Information</ModalHeader>
        <ModalBody>
          <FormControl mt={1} isRequired>
            <FormLabel>GSTIN Number</FormLabel>
            <InputGroup>
              <Input
                type={"Text"}
                placeholder="Enter Account Number"
                focusBorderColor={BACKGROUND_COLOR_DARK}
                _hover={{ borderColor: BACKGROUND_COLOR_DARK }}
                fontSize={"1.1rem"}
                borderColor={"#ddd"}
                borderRadius={"10px"}
                size="lg"
                onChange={(e) => {
                  setFormValues({
                    ...formValues,
                    gstNumber: e.target.value,
                  });
                }}
              />
            </InputGroup>
          </FormControl>
        </ModalBody>
        <ModalFooter
          display={"flex"}
          flexDirection={"column"}
          rowGap={4}
          alignItems={"center"}
          mt={2}
        >
          <Button
            width={"100%"}
            colorScheme="teal"
            onClick={() => {
              handleFormSubmit();
            }}
          >
            Upload
          </Button>
          <Button
            width={"100%"}
            onClick={handleGstDetailsModalCancel}
            variant={"outline"}
          >
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default FillGstDetailsModal;
